<template>
  <div class="page-footer">
    <hr>
    <div class="footer-links">
      <a href="https://www.iosb.fraunhofer.de/de/impressum.html">Impressum</a>
      <a href="https://dsi.informationssicherheit.fraunhofer.de/de/dsi/gitlab.cc-asp.fraunhofer.de/full">Datenschutz</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>
